<template>
  <v-card class="protocolInfo pt-5 pl-5 pr-5 pb-5" v-if="hide && protocolInfo">
    <transition name="fade">
      <div>
        <h3 class="colorblue">
          О закупке
          <span v-if="protocolInfo.purchase && protocolInfo.purchase.isSmp">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on" style="color: tomato">{{
                  protocolInfo.purchase && protocolInfo.purchase.isSmp && "СМП"
                }}</span>
              </template>
              <span>Закупка для СМП</span>
            </v-tooltip>
          </span>
        </h3>
        <ul class="clear">
          <li v-if="protocolInfo.notificationNumber">
            № закупки:
            <span v-if="protocolInfo.purchase && protocolInfo.purchase.href">
              <a :href="protocolInfo.purchase.href" target="_blank">{{
                protocolInfo.notificationNumber
              }}</a>
            </span>
            <span v-else> {{ protocolInfo.notificationNumber }}</span>
          </li>
          <li>
            Предмет:
            <v-tooltip bottom v-if="protocolInfo.name">
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ protocolInfo.name }}</span>
              </template>
              <span>Предмет закупки</span>
            </v-tooltip>
            <v-tooltip bottom v-else-if="protocolInfo.purchaseObjectInfo">
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ protocolInfo.purchaseObjectInfo }}</span>
              </template>
              <span>Предмет закупки</span>
            </v-tooltip>
            <span v-else>N/A</span>
          </li>
          <li>
            Срок исполнения:
            <span
              class="onHover"
              v-if="protocolInfo.purchase && protocolInfo.purchase.deliveryDate"
              @click="setDate(protocolInfo.contractTerm.date)"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{
                    moment(protocolInfo.purchase.deliveryDate).format(
                      "DD.MM.YYYY"
                    )
                  }}</span>
                </template>
                <span>Срок выполнения обязательств</span>
              </v-tooltip>
            </span>
            <span
              v-else-if="
                protocolInfo.purchase && protocolInfo.purchase.deliveryTerm
              "
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{
                    cutTextLength(protocolInfo.purchase.deliveryTerm)
                  }}</span>
                </template>
                <span
                  >Срок выполнения обязательств: <br />
                  <p>{{ protocolInfo.purchase.deliveryTerm }}</p></span
                >
              </v-tooltip>
            </span>
            <span v-else>N/A</span>
          </li>

          <li>
            Срок контракта:
            <span
              class="onHover"
              v-if="protocolInfo.contractTerm && protocolInfo.contractTerm.date"
              @click="setDate(protocolInfo.contractTerm.date)"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{ protocolInfo.contractTerm.date }}</span>
                </template>
                <span>Срок действия контракта</span>
              </v-tooltip>
            </span>
            <span
              v-else-if="
                protocolInfo.contractTerm && protocolInfo.contractTerm.text
              "
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{
                    cutTextLength(protocolInfo.contractTerm.text)
                  }}</span>
                </template>
                <span
                  >Срок действия контракта: <br />
                  <p>{{ protocolInfo.contractTerm.text }}</p></span
                >
              </v-tooltip>
            </span>
            <span v-else>N/A</span>
          </li>

          <li>
            НМЦ:
            <span v-if="protocolInfo.price">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span
                    class="onHover"
                    v-on="on"
                    @click="changeSumm(protocolInfo.price)"
                  >
                    {{ addCommas(protocolInfo.price) }} ₽
                  </span>
                </template>
                <span>Начальная цена контракта</span>
              </v-tooltip>
            </span>
            <span v-else>N/A</span>
          </li>
          <li>
            Предложение:
            <span
              v-if="protocolInfo.purchase && protocolInfo.purchase.lowPrice"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span
                    class="onHover"
                    v-on="on"
                    @click="changeSumm(protocolInfo.purchase.lowPrice)"
                  >
                    {{ addCommas(protocolInfo.purchase.lowPrice) }} ₽
                  </span>
                </template>
                <span>Предложенная цена контракта</span>
              </v-tooltip>
            </span>
            <span v-else>N/A</span>
            <span
              v-if="
                protocolInfo.purchase &&
                protocolInfo.purchase.lowPrice &&
                protocolInfo.price
              "
            >
              ({{
                (
                  ((protocolInfo.price - protocolInfo.purchase.lowPrice) /
                    protocolInfo.price) *
                  100 * -1
                ).toFixed(2)
              }}
              %)
            </span>
          </li>
          <li
            v-if="
              protocolInfo.endDate &&
              moment(protocolInfo.endDate).isAfter(moment().format())
            "
          >
            Обеспечения заявки:
            <span
              v-if="protocolInfo.purchase && protocolInfo.purchase.appguarantee"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span
                    class="onHover"
                    v-on="on"
                    @click="changeSumm(protocolInfo.purchase.appguarantee, 1)"
                  >
                    {{ addCommas(protocolInfo.purchase.appguarantee) }}
                  </span>
                </template>
                <span>Размер обеспечения заявки</span>
              </v-tooltip>
            </span>
            <span v-else>N/A</span>
          </li>
          <li>
            Обеспечение исполнения:
            <span v-if="protocolInfo.guaranteeing">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span
                    class="onHover"
                    v-on="on"
                    @click="changeSumm(protocolInfo.guaranteeing, 2)"
                  >
                    {{ addCommas(protocolInfo.guaranteeing) }} ₽
                  </span>
                </template>
                <span>Размер обеспечения исполнения</span>
              </v-tooltip>
            </span>
            <span v-else>N/A</span>
          </li>
          <li v-if="protocolInfo.purchase && protocolInfo.purchase.isSmp">
            <strong>Обеспечение исполнения для СМП</strong>:
            <span
              v-if="
                protocolInfo.price &&
                protocolInfo.guaranteeing &&
                protocolInfo.purchase.lowPrice
              "
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span
                    class="onHover"
                    v-on="on"
                    v-if="guaranteeingSMP() > 0"
                    @click="changeSumm(guaranteeingSMP(), 2)"
                  >
                    {{ addCommas(guaranteeingSMP()) }} ₽
                  </span>
                </template>
                <span>Обеспечение исполнения для СМП</span>
              </v-tooltip>
            </span>
            <span v-else>N/A</span>
          </li>
          <li>
            Гарантийные обязательства:
            <span
              v-if="
                protocolInfo.purchase &&
                protocolInfo.purchase.warranty &&
                protocolInfo.purchase.warranty.warranty_size
              "
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span
                    class="onHover"
                    v-on="on"
                    @click="
                      changeSumm(
                        protocolInfo.purchase.warranty.warranty_size,
                        3
                      )
                    "
                  >
                    {{
                      addCommas(protocolInfo.purchase.warranty.warranty_size)
                    }}
                    ₽
                  </span>
                </template>
                <span>Гарантийные обязательства</span>
              </v-tooltip>
            </span>
            <span v-else>N/A</span>
          </li>

          <!-- <li
            v-if="protocolInfo.purchase && protocolInfo.purchase.deliveryTerm"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ protocolInfo.purchase.deliveryTerm }}</span>
              </template>
              <span>Описание выполнения обязательств</span>
            </v-tooltip>
          </li>
          <li v-if="protocolInfo.deliveryTerm">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ protocolInfo.deliveryTerm }}</span>
              </template>
              <span>Описание выполнения обязательств</span>
            </v-tooltip>
          </li> -->
        </ul>
      </div>
    </transition>
    <transition name="fade">
      <div>
        <h3 class="colorblue">О Победителе</h3>
        <ul class="clear">
          <li>
            <span v-if="protocolInfo.egrul && protocolInfo.egrul.shortname">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ protocolInfo.egrul.shortname }}
                  </span>
                </template>
                <span>Наименование компании победителя</span>
              </v-tooltip>
            </span>
            <span v-else-if="protocolInfo.winner_name">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ protocolInfo.winner_name }}
                  </span>
                </template>
                <span>Наименование компании победителя</span>
              </v-tooltip>
            </span>
            <span v-else>N/A</span>
          </li>
          <li>
            ИНН:
            <span v-if="protocolInfo.winner_inn">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ protocolInfo.winner_inn }}
                  </span>
                </template>
                <span>ИНН компании победителя</span>
              </v-tooltip>
            </span>
            <span v-else>N/A</span>
          </li>
          <!-- <li>
            Регистрация:
            <span
              v-if="
                winnerInfo &&
                winnerInfo.main &&
                winnerInfo.main.data &&
                winnerInfo.main.data.state &&
                winnerInfo.main.data.state.registration_date &&
                moment(
                  parseInt(
                    String(winnerInfo.main.data.state.registration_date).slice(
                      0,
                      -3
                    )
                  )
                ).format('DD.MM.YYYY') !== '01.01.1970'
              "
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{
                      moment(
                        parseInt(
                          String(
                            winnerInfo.main.data.state.registration_date
                          ).slice(0, -3)
                        )
                      ).format("DD.MM.YYYY")
                    }}
                  </span>
                </template>
                <span>Дата регистрации</span>
              </v-tooltip>
            </span>
            <span
              v-else-if="
                protocolInfo.egrul &&
                protocolInfo.egrul.regdate &&
                moment(protocolInfo.egrul.regdate).format('DD.MM.YYYY') !==
                  '01.01.1970'
              "
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{
                      moment(protocolInfo.egrul.regdate).format("DD.MM.YYYY")
                    }}
                  </span>
                </template>
                <span>Дата регистрации</span>
              </v-tooltip>
            </span>

            <span v-else>N/A</span>
          </li> -->
        </ul>
        <ul class="clear">
          <li v-for="(item, id) in wins" :key="id">
            В {{ item.year }}:
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  {{ String(item.total).replace("-", "") }}
                </span>
              </template>
              <span>Всего побед за год</span>
            </v-tooltip>
            на
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  {{
                    String(addCommas(item.totalsum))
                      .replace(",00", "")
                      .replace("-", "")
                  }}
                </span>
              </template>
              <span>Сумма контрактов за год</span>
            </v-tooltip>
            в
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  {{ item.year }}
                </span>
              </template>
              <span>Год победы</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">info</v-icon>
              </template>

              <span>
                44: {{ item.fz44 }} <br />
                94: {{ item.fz94 }}<br />
                223: {{ item.fz223 }}<br />
              </span>
            </v-tooltip>
          </li>
        </ul>
        <span
          v-if="winnerInfo && winnerInfo.finans"
          class="colorblue"
          style="font-size: 16px"
          >За {{ parseInt(moment().format("YYYY")) - 1 }} год:</span
        >
        <ul class="clear" v-if="winnerInfo && winnerInfo.finans">
          <li>
            Выручка
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  {{
                    winnerInfo.finans.proceeds !== 0
                      ? String(addCommas(winnerInfo.finans.proceeds)).replace(
                          ",00",
                          ""
                        )
                      : 0
                  }}
                  т.р
                </span>
              </template>
              <span>Выручка</span>
            </v-tooltip>
          </li>
          <li>
            Прибыль
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  {{
                    winnerInfo.finans.profit !== 0
                      ? String(addCommas(winnerInfo.finans.profit)).replace(
                          ",00",
                          ""
                        )
                      : 0
                  }}
                  т.р
                </span>
              </template>
              <span>Прибыль</span>
            </v-tooltip>
          </li>
          <li>
            Баланс
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  {{
                    winnerInfo.finans.valbal !== 0
                      ? String(addCommas(winnerInfo.finans.valbal)).replace(
                          ",00",
                          ""
                        )
                      : 0
                  }}
                  т.р
                </span>
              </template>
              <span>Баланс</span>
            </v-tooltip>
          </li>
        </ul>
      </div>
    </transition>
  </v-card>
</template>
<script>
import moment from "moment";
export default {
  name: "protocolInfo",
  components: {},
  data: () => ({
    moment,
    showedIcon: "mdi-chevron-left",
    hideedIcon: "mdi-chevron-right",
    wins: [],
  }),
  props: {
    hide: { type: Boolean, default: false },
    protocolInfo: {},
  },
  computed: {
    winnerInfo() {
      return this.$store.getters.winner_info;
    },
    selectedIcon() {
      return this.hide ? this.hideedIcon : this.showedIcon;
    },
  },
  methods: {
    guaranteeingSMP() {
      const guaranteeing = this.protocolInfo.guaranteeing;
      const price = this.protocolInfo.price;
      const lowPrice = this.protocolInfo.purchase.lowPrice;
      if (lowPrice <= price) {
        return Number(((guaranteeing / price) * lowPrice).toFixed(2));
      }
      return guaranteeing;
    },
    smpPrice() {
      const price =
        this.protocolInfo.price && Number(parseInt(this.protocolInfo.price));
      const lowPrice =
        this.protocolInfo.purchase.lowPrice &&
        Number(parseInt(this.protocolInfo.purchase.lowPrice));
      return this.addCommas((price - (lowPrice / price) * 100).toFixed(2));
    },
    async setDate(date) {
      const d = this.getNormalizeDate(date, "en");
      d &&
        (await this.$store.dispatch("SET_CALC_PARAM", {
          param: "date2",
          value: moment(d).add(31, "days").format("DD.MM.YYYY"),
        }));

      this.protocolInfo.fz === 615 &&
        d &&
        (await this.$store.dispatch("SET_CALC_PARAM", {
          param: "date2",
          value: moment(d).add(61, "days").format("DD.MM.YYYY"),
        }));

      d &&
        (await this.$store.dispatch("SET_CALC_PARAM", {
          param: "msgDate",
          value: true,
        }));

      const dd1 = this.$store.getters.calc.date;
      const dd2 = this.$store.getters.calc.date2;

      dd1 &&
        dd2 &&
        (await this.$store.dispatch("SET_CALC_PARAM", {
          param: "days",
          value: await this.calcDays(dd1, dd2),
        }));
    },
    async changeSumm(summ, num = -1) {
      switch (num) {
        case -1: {
          await this.$store.dispatch("SET_CALC_PARAM", {
            param: "summ",
            value: summ,
          });
          break;
        }
        case 1: {
          await this.$store.dispatch("SET_CALC_PARAM", {
            param: "summ",
            value: summ,
          });
          await this.$store.dispatch("SET_CALC_PARAM", {
            param: "quaranteesVal",
            value: 2,
          });
          break;
        }
        case 2: {
          await this.$store.dispatch("SET_CALC_PARAM", {
            param: "summ",
            value: summ,
          });
          await this.$store.dispatch("SET_CALC_PARAM", {
            param: "quaranteesVal",
            value: 1,
          });
          break;
        }
        case 3: {
          await this.$store.dispatch("SET_CALC_PARAM", {
            param: "summ",
            value: summ,
          });
          await this.$store.dispatch("SET_CALC_PARAM", {
            param: "quaranteesVal",
            value: 4,
          });
          break;
        }
        default:
          break;
      }
    },
  },
};
</script>
<style lang="sass" scoped>
ul.clear
  list-style: none
  padding-left: 0px
  font-size: 0.85em
</style>
